import { render, staticRenderFns } from "./order-placed.vue?vue&type=template&id=5bd1e783&scoped=true&"
import script from "./order-placed.vue?vue&type=script&lang=js&"
export * from "./order-placed.vue?vue&type=script&lang=js&"
import style0 from "./order-placed.vue?vue&type=style&index=0&id=5bd1e783&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd1e783",
  null
  
)

export default component.exports